export const HOSTNAME = window.location.hostname.includes('localhost')
  ? 'dev.hsbc.inspire.direct'
  : window.location.hostname;
